const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_BANK_ID(state, bankId) {
    state.bankId = bankId
  },
  UPDATE_ACCOUNT_NO(state, accountNo) {
    state.accountNo = accountNo
  },
  UPDATE_BANK_NAME_OTHER(state, bankNameOther) {
    state.bankNameOther = bankNameOther
  }
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateBankId({
    commit
  }, bankId) {
    commit('UPDATE_BANK_ID', bankId);
  },
  updateAccountNo({
    commit
  }, accountNo) {
    commit('UPDATE_ACCOUNT_NO', accountNo);
  },
  updateBankNameOther({
    commit
  }, bankNameOther) {
    commit('UPDATE_BANK_NAME_OTHER', bankNameOther);
  }
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  BankId: state => {
    return state.bankId
  },
  AccountNo: state => {
    return state.accountNo
  },
  BankNameOther: state => {
    return state.bankNameOther
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      bankId: 0,
      accountNo: "",
      bankNameOther: ""
    }
  },
  getters,
  actions,
  mutations
}
